/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionAnswerDto
 */
export interface QuestionAnswerDto {
    /**
     * Identifiant unique de la question (obligatoire)
     * @type {string}
     * @memberof QuestionAnswerDto
     */
    questionId: string;
    /**
     * Identifiant de la réponse possible sélectionnée
     * @type {string}
     * @memberof QuestionAnswerDto
     */
    possibleAnswerId?: string | null;
    /**
     * Texte de réponse libre
     * @type {string}
     * @memberof QuestionAnswerDto
     */
    answerText?: string | null;
    /**
     * Valeur de réponse (peut être de tout type)
     * @type {object}
     * @memberof QuestionAnswerDto
     */
    answerValue?: object | null;
    /**
     * Liste des identifiants des réponses possibles multiples
     * @type {Array<string>}
     * @memberof QuestionAnswerDto
     */
    multiplePossibleAnswerIds?: Array<string>;
}

/**
 * Check if a given object implements the QuestionAnswerDto interface.
 */
export function instanceOfQuestionAnswerDto(value: object): value is QuestionAnswerDto {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    return true;
}

export function QuestionAnswerDtoFromJSON(json: any): QuestionAnswerDto {
    return QuestionAnswerDtoFromJSONTyped(json, false);
}

export function QuestionAnswerDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionAnswerDto {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'possibleAnswerId': json['possibleAnswerId'] == null ? undefined : json['possibleAnswerId'],
        'answerText': json['answerText'] == null ? undefined : json['answerText'],
        'answerValue': json['answerValue'] == null ? undefined : json['answerValue'],
        'multiplePossibleAnswerIds': json['multiplePossibleAnswerIds'] == null ? undefined : json['multiplePossibleAnswerIds'],
    };
}

export function QuestionAnswerDtoToJSON(json: any): QuestionAnswerDto {
    return QuestionAnswerDtoToJSONTyped(json, false);
}

export function QuestionAnswerDtoToJSONTyped(value?: QuestionAnswerDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'possibleAnswerId': value['possibleAnswerId'],
        'answerText': value['answerText'],
        'answerValue': value['answerValue'],
        'multiplePossibleAnswerIds': value['multiplePossibleAnswerIds'],
    };
}

